import { SlotAnimationConstant, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { IObject } from "@quest/adapter-interface";

export let gameConstants: IObject = {
  GAME_CONTAINER_DIV: "gameContainer",
  lineLayout: [
    [1, 2, 3, 4, 5],
    [6, 7, 8, 9, 10],
    [11, 12, 13, 14, 15],
    [16, 17, 18, 19, 20],
    [1, 2, 8, 4, 5],
    [6, 7, 13, 9, 10],
    [11, 12, 18, 14, 15],
    [6, 7, 3, 9, 10],
    [11, 12, 8, 14, 15],
    [16, 17, 13, 19, 20],
    [1, 7, 13, 9, 5],
    [6, 12, 18, 14, 10],
    [16, 12, 8, 14, 20],
    [11, 7, 3, 9, 15],
    [1, 7, 3, 9, 5],
    [6, 12, 8, 14, 10],
    [11, 17, 13, 19, 15],
    [16, 12, 18, 14, 20],
    [11, 7, 13, 9, 15],
    [6, 2, 8, 4, 10],
    [1, 2, 8, 14, 15],
    [6, 7, 13, 19, 20],
    [11, 12, 8, 4, 5],
    [16, 17, 13, 9, 10],
    [1, 7, 3, 9, 15],
    [6, 12, 8, 14, 20],
    [16, 12, 18, 14, 10],
    [11, 7, 13, 9, 5],
    [11, 7, 3, 9, 5],
    [16, 12, 8, 14, 10],
    [6, 12, 18, 14, 20],
    [1, 7, 13, 9, 15],
    [1, 2, 3, 9, 10],
    [6, 7, 8, 14, 15],
    [11, 12, 13, 19, 20],
    [16, 17, 18, 14, 15],
    [11, 12, 13, 9, 10],
    [6, 7, 8, 4, 5],
    [1, 7, 13, 19, 15],
    [16, 12, 8, 4, 10],
    [6, 2, 8, 14, 20],
    [11, 17, 13, 9, 5],
    [1, 2, 8, 14, 20],
    [16, 17, 13, 9, 5],
    [1, 7, 13, 19, 20],
    [16, 12, 8, 4, 5],
    [6, 2, 3, 4, 10],
    [11, 7, 8, 9, 15],
    [16, 12, 13, 14, 20],
    [11, 17, 18, 19, 15],
    [6, 12, 13, 14, 10],
    [1, 7, 8, 9, 5],
    [1, 2, 8, 4, 10],
    [6, 7, 13, 9, 15],
    [11, 12, 18, 14, 20],
    [16, 17, 13, 19, 15],
    [11, 12, 8, 14, 10],
    [6, 7, 3, 9, 5],
    [6, 2, 8, 14, 10],
    [11, 17, 13, 9, 15],
    [1, 7, 18, 9, 5],
    [16, 12, 3, 14, 20],
    [1, 17, 3, 19, 5],
    [16, 2, 18, 4, 20],
    [16, 7, 18, 9, 20],
    [1, 12, 3, 14, 5],
    [6, 2, 13, 4, 10],
    [11, 17, 8, 19, 15],
    [6, 2, 18, 4, 10],
    [11, 17, 3, 19, 15],
    [1, 2, 13, 4, 5],
    [6, 7, 18, 9, 10],
    [16, 17, 8, 19, 20],
    [11, 12, 3, 14, 15],
    [1, 2, 18, 4, 5],
    [16, 17, 3, 19, 20],
    [1, 2, 3, 4, 10],
    [6, 7, 8, 9, 5],
    [16, 17, 18, 19, 15],
    [11, 12, 13, 14, 20],
  ],

  // now changed for 7x10
  OFFSET_INCREMENT_X5: 5,
  ADD_IN_X: -51,

  // BIG WIN CONSTANTS
  NO_WIN: 0,
  BIG_WIN_MULTIPLIER: 10,
  SUPER_WIN_MULTIPLIER: 20,
  EPIC_WIN_MULTIPLIER: 50,
  CRAZY_WIN_MULTIPLIER: 100,

  BIG_WIN: 1,
  SUPER_WIN: 2,
  EPIC_WIN: 3,
  CRAZY_WIN: 4,

  //big win threshold
  BigWinMultiplier: 10,
  SuperWinMultiplier: 20,
  EpicWinMultiplier: 50,
  CrazyWinMultiplier: 100,
  WINTICKUP_22: 5,

  MYSTERY_SYMBOL_ID: 77,
  SPECIAL_MYSTERY_SYMBOL_ID: 78,
  MYSTERY_SYMBOL_GAME_ID: 19,
  SPECIAL_MYSTERY_SYMBOL_GAME_ID: 20,
  NOTE_BLANK_SYMBOL_ID: 22,
  MAGNIFY_BLANK_SYMBOL_ID: 23,
  KEY_BLANK_SYMBOL_ID: 24,
  SPECIAL_SYMBOLS_CONVERTED: [11, 12, 13],

  MAN_SYMBOL_1X3: 200,
  MAN_SYMBOL_1X5: 250,
  MAN_SYMBOL_1X3_ID: 15,
  MAN_SYMBOL_1X5_ID: 16,
  MAN_SYMBOL_1X3_STACK_ID: 17,
  MAN_SYMBOL_1X5_STACK_ID: 18,

  TRANSPARENT_SYMBOL_ID: 21,
  MAN_SYMBOL_ID: 1,

  // Stack Man & Lady symbols Id, its size & Stack Replace Id for base & free game
  // [StackId StackSize StackReplaceId]
  MAN_AND_LADY_STACK_DATA: [
    [15, 3, 17],
    [16, 5, 18]
  ],

  SPECIAL_SYMBOL_NOTE: 51,
  SPECIAL_SYMBOL_MAGNIFY: 52,
  SPECIAL_SYMBOL_KEY: 53,
  SPECIAL_SYMBOL_SPOTLIGHT: 60,
  SPECIAL_SYMBOL_NOTE_ID: 11,
  SPECIAL_SYMBOL_MAGNIFY_ID: 12,
  SPECIAL_SYMBOL_KEY_ID: 13,
  SPECIAL_SYMBOL_SPOTLIGHT_ID: 14,
  SPECIAL_SYMBOLS: [11, 12, 13],
  //TIMERS
  TIMER_100: 100,
  TIMER_200: 200,
  TIMER_250: 250,
  TIMER_300: 300,
  TIMER_400: 400,
  TIMER_500: 500,
  TIMER_600: 600,
  TIMER_700: 700,
  TIMER_800: 800,
  TIMER_1000: 1000,
  TIMER_1100: 1100,
  TIMER_2000: 2000,

  // Cascade Reels Constants
  HIDE_SYMBOLS_ON_BURST_ANIMATION_PLAY: "hide_Symbols_On_Burst_Animation_Play",

  START_REEL_DROP_ON_BURST_ANIMATION_PLAY: "Start_Reel_Drop_On_Burst_Animation_Play",
  CASCADE_REEL_CONTAINER_ID: "reelContainer0",
  CASCADE_SPINE_STRING_ID: "cascade_effect",
  REEL_DROP_TWEEN_DURATION: 300,
  REEL_DROP_TWEEN_DELAY: 200,

  STOP_CASCADE_BOUNCE: 35,
  STOP_CASCADE_BOUNCE_TIME: 300,
  STOP_CASCADE_BOUNCE_TIMEOUT: 300,
  NEXT_LINE_TOGGLE: "delayForLineToggle",
  DELAY_FOR_NEXT_LINE_TOGGLE_TIME: 2500,
  BLUE_WIN_FRAME_SYMBOL_ID: [1, 3, 5, 7],
  BLUE_WIN_FRAME_TINT_COLOR: 0xb9eefd,
  RED_WIN_FRAME_TINT_COLOR: 0xfdaf3b,
  BORDER_HIGHLIGHT_MULTIPLER: 4.3,
  PROGRESS_SHIFT_LIMIT: 521,

  // Big Win, Fg Intro & Outro Blur BG
  SHOW_BIG_WIN_BLUR_BG: "SHOW_BIG_WIN_BLUR_BG",
  SHOW_SUPER_WIN_BLUR_BG: "SHOW_SUPER_WIN_BLUR_BG",
  SHOW_EPIC_WIN_BLUR_BG: "SHOW_EPIC_WIN_BLUR_BG",
  SHOW_CRAZY_WIN_BLUR_BG: "SHOW_CRAZY_WIN_BLUR_BG",
  SHOW_INVESTIGATION_BLUR_BG: "SHOW_INVESTIGATION_BLUR_BG",
  SHOW_CLUE_BLUR_BG: "SHOW_CLUE_BLUR_BG",
  SHOW_GRAND_BLUR_BG: "SHOW_GRAND_BLUR_BG",
  INVESTIGATION_BG_SHOW: "INVESTIGATION_BG_SHOW",
  SHIFT_MULTIPLIER_SYM: 8.5,
  MAX_PROGRESS_COUNT: 7,
  CLUE_SECTIONS_DISABLED: [
    "criminalUnrevealed_A",
    "criminalUnrevealed_B",
    "criminalUnrevealed_C",
    "criminalUnrevealed_D",
    "criminalUnrevealed_E",
    "locationUnrevealed_F",
    "locationUnrevealed_G",
    "locationUnrevealed_H",
    "locationUnrevealed_I",
    "locationUnrevealed_J",
    "weaponUnrevealed_K",
    "weaponUnrevealed_L",
    "weaponUnrevealed_M",
    "weaponUnrevealed_N",
    "weaponUnrevealed_O",

    "criminalWire_A_Grey",
    "criminalWire_B_Grey",
    "criminalWire_C_Grey",
    "criminalWire_D_Grey",
    "criminalWire_E_Grey",
    "locationWire_F_Grey",
    "locationWire_G_Grey",
    "locationWire_H_Grey",
    "locationWire_I_Grey",
    "locationWire_J_Grey",
    "weaponWire_K_Grey",
    "weaponWire_L_Grey",
    "weaponWire_M_Grey",
    "weaponWire_N_Grey",
    "weaponWire_O_Grey",


    "criminal_A_Pin_Grey",
    "criminal_B_Pin_Grey",
    "criminal_C_Pin_Grey",
    "criminal_D_Pin_Grey",
    "criminal_E_Pin_Grey",
    "location_F_Pin_Grey",
    "location_G_Pin_Grey",
    "location_H_Pin_Grey",
    "location_I_Pin_Grey",
    "location_J_Pin_Grey",
    "weapon_K_Pin_Grey",
    "weapon_L_Pin_Grey",
    "weapon_M_Pin_Grey",
    "weapon_N_Pin_Grey",
    "weapon_O_Pin_Grey",


  ],
  CLUE_SECTIONS_ENABLED_CARDS: [
    "criminal_A",
    "criminal_B",
    "criminal_C",
    "criminal_D",
    "criminal_E",
    "location_F",
    "location_G",
    "location_H",
    "location_I",
    "location_J",
    "weapon_K",
    "weapon_L",
    "weapon_M",
    "weapon_N",
    "weapon_O",

    "criminalWire_A_Red",
    "criminalWire_B_Red",
    "criminalWire_C_Red",
    "criminalWire_D_Red",
    "criminalWire_E_Red",
    "locationWire_F_Red",
    "locationWire_G_Red",
    "locationWire_H_Red",
    "locationWire_I_Red",
    "locationWire_J_Red",
    "weaponWire_K_Red",
    "weaponWire_L_Red",
    "weaponWire_M_Red",
    "weaponWire_N_Red",
    "weaponWire_O_Red",
    "criminal_A_Pin_Red",
    "criminal_B_Pin_Red",
    "criminal_C_Pin_Red",
    "criminal_D_Pin_Red",
    "criminal_E_Pin_Red",
    "location_F_Pin_Red",
    "location_G_Pin_Red",
    "location_H_Pin_Red",
    "location_I_Pin_Red",
    "location_J_Pin_Red",
    "weapon_K_Pin_Red",
    "weapon_L_Pin_Red",
    "weapon_M_Pin_Red",
    "weapon_N_Pin_Red",
    "weapon_O_Pin_Red",
  ]
};

export let spineConstants: IObject = {
  //  BIG WIN SPINE IDS
  BIGWIN_IN_ANIM: "big_win_desktop_in_fg",
  BIGWIN_BACKGROUND_IN_ANIM: "big_win_desktop_in_bg",
  BIGWIN_LOOP_ANIM: "big_win_desktop_loop_fg",
  BIGWIN_BACKGROUND_LOOP_ANIM: "big_win_desktop_loop_bg",
  BIGWIN_OUT_ANIM: "big_win_desktop_out_fg",
  BIGWIN_BACKGROUND_OUT_ANIM: "big_win_desktop_out_bg",

  //  SUPER WIN SPINE IDS
  SUPERWIN_LOOP_ANIM: "super_win_loop_desktop_fg",
  SUPERWIN_BACKGROUND_LOOP_ANIM: "super_win_loop_desktop_bg",
  SUPERWIN_OUT_ANIM: "super_win_out_desktop_fg",
  SUPERWIN_BACKGROUND_OUT_ANIM: "super_win_out_desktop_bg",

  //  EPIC WIN SPINE IDS
  EPICWIN_LOOP_ANIM: "epic_win_loop_desktop_fg",
  EPICWIN_BACKGROUND_LOOP_ANIM: "epic_win_loop_desktop_bg",
  EPICWIN_OUT_ANIM: "epic_win_out_desktop_fg",
  EPICWIN_BACKGROUND_OUT_ANIM: "epic_win_out_desktop_bg",

  //  CRAZY WIN SPINE IDS
  CRAZYWIN_LOOP_ANIM: "crazy_win_loop_desktop_fg",
  CRAZYWIN_BACKGROUND_LOOP_ANIM: "crazy_win_loop_desktop_bg",
  CRAZYWIN_OUT_ANIM: "crazy_win_out_desktop_fg",
  CRAZYWIN_BACKGROUND_OUT_ANIM: "crazy_win_out_desktop_bg",

  // WIN FRAME SPINE IDS
  WINFRAME_VERTICAL: "winframe_vertical",
  WINFRAME_HORIZONTAL: "winframe_horizontal",
  WIN_FRAME: "winframe",

  //BACKGROUND
  INVESTIGATION_IDLE: "investigation_room_bg",
  INVESTIGATION_IDLE_PORT: "investigation_room_bg_port",

  FREEGAME_IDLE_SPINE_PORTRAIT: "freegame_idle_portrait",

  // WIN CONVERSION ANIMATION

  /**
   * @Win_Conversion_Animations
   */
  BIGWIN_TO_SUPERWIN_ANIM: "big_win_to_super_win_desktop_fg",
  BIGWIN_TO_SUPERWIN_BACKGROUND_ANIM: "big_win_to_super_win_desktop_bg",

  SUPER_TO_EPIC_WIN_ANIM: "super_win_to_epic_win_desktop_fg",
  SUPER_TO_EPIC_WIN_BACKGROUND_ANIM: "super_win_to_epic_win_desktop_bg",

  EPIC_TO_CRAZY_WIN_ANIM: "epic_win_to_crazy_win_desktop_fg",
  EPIC_TO_CRAZY_WIN_BACKGROUND_ANIM: "epic_win_to_crazy_win_desktop_bg",

  //FreegameSpine

  FG_BIG_WIN_DESKTOP_BG: "freegame_big_Win_bg",
  FG_BIG_WIN_DESKTOP_START_BG: "big_win_desktop_in_bg",
  FG_BIG_WIN_DESKTOP_LOOP_BG: "big_win_desktop_loop_bg",
  FG_BIG_WIN_DESKTOP_END_BG: "big_win_desktop_out_bg",

  FG_INTRO_DESKTOP_LAYER_BG_IN: "freespin_in_desktop_bg", // In spine
  FG_INTRO_DESKTOP_LAYER_BG_STATIC: "freespin_loop_desktop_bg", // Loop Spine
  FG_INTRO_DESKTOP_LAYER_BG_OUT: "freespin_out_desktop_bg", // Out spine

  FG_INTRO_LAYER_BG_IN_PORTRAIT: "freespin_in_portrait_bg", // In spine
  FG_INTRO_LAYER_BG_STATIC_PORTRAIT: "freespin_loop_portrait_bg", // Loop Spine
  FG_INTRO_LAYER_BG_OUT_PORTRAIT: "freespin_out_portrait_bg", // Out spine

  BASEGAME_IDLE_PORT: "basegame_idle_portrait",

};

// (SlotConstantsBehavior.WrapperTopBarHeightDesktop = 32),
SlotConstantsBehavior.GAME_NAME = "Noir Nights"
SlotConstantsBehavior.ADD_IN_Y = 90;
SlotConstantsBehavior.FONT_LIST = ["Arial", "ArialBlack", "MinionPro-Bold", "ArialBold", "Albertus-Nova-W07-Bold"];

SlotConstantsBehavior.REEL_BOTTOM_SPACE_LANDSCAPE = 0;
SlotConstantsBehavior.REEL_BOTTOM_SPACE = 0;
SlotConstantsBehavior.BASEGAME_IDLE_SPINE = "basegame_idle_desktop";
SlotConstantsBehavior.FREEGAME_IDLE_SPINE = "freegame_idle_desktop";

//  Free Game Intro Outro
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_IN = "basegame_idle_desktop"; // In spine
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_STATIC = "basegame_idle_desktop"; // Loop Spine
SlotAnimationConstant.FG_INTRO_DESKTOP_BG_OUT = "basegame_idle_desktop"; // Out spine

SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_IN = "basegame_idle_portrait"; // In spine
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_STATIC = "basegame_idle_portrait"; // Loop Spine
SlotAnimationConstant.FG_INTRO_PORTRAIT_BG_OUT = "basegame_idle_portrait"; // Out spine

SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_IN = "basegame_idle_portrait"; // In spine
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_LOOP = "basegame_idle_portrait"; // Loop Spine
SlotAnimationConstant.FG_OUTRO_PORTRAIT_BG_OUT = "basegame_idle_portrait"; // Out spine


SlotAnimationConstant.FG_INTRO_DESKTOP_IN = "freespin_intro_in"; // In spine
SlotAnimationConstant.FG_INTRO_DESKTOP_STATIC = "freespin_intro_loop"; // Loop spine
SlotAnimationConstant.FG_INTRO_DESKTOP_OUT = "freespin_intro_out"; // Out spine

SlotAnimationConstant.FG_BIG_WIN_DESKTOP = "freegame_big_Win";

SlotAnimationConstant.FG_INTRO_PORTRAIT_IN = "freespin_intro_in";
SlotAnimationConstant.FG_INTRO_PORTRAIT_STATIC = "freespin_intro_loop"
SlotAnimationConstant.FG_INTRO_PORTRAIT_OUT = "freespin_intro_out";

SlotAnimationConstant.FG_BIG_WIN_DESKTOP_START = "big_win_desktop_in_fg";
SlotAnimationConstant.FG_BIG_WIN_DESKTOP_LOOP = "big_win_desktop_loop_fg";
SlotAnimationConstant.FG_BIG_WIN_DESKTOP_END = "big_win_desktop_out_fg";
SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_START = "big_win_portrait_in_fg";
SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_LOOP = "big_win_portrait_loop_fg";
SlotAnimationConstant.FG_BIG_WIN_PORTRAIT_END = "big_win_portrait_out_fg";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_IN = "freespin_outro_in";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_LOOP = "freespin_outro_loop";
SlotAnimationConstant.FG_OUTRO_PORTRAIT_OUT = "freespin_outro_out";
